import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";
import { useSettings } from "../contexts/SettingsContext";
import { formatApiError, resolveUrl } from "../lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const { t } = useI18n();
  const { settings } = useSettings();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // If already authenticated, redirect declaratively (avoid setState-in-render warning)
  if (user && user !== false) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/owner"} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/owner");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--brand-bg)" }} data-testid="login-page">
      <div className="w-full max-w-md card-surface p-10">
        <Link to="/" className="flex items-center gap-3 justify-center mb-8">
          {settings?.logo_path ? <img src={resolveUrl(settings.logo_path)} alt="" className="h-8" /> : null}
          {!(settings?.logo_only_mode && settings?.logo_path) && (
            <span className="font-serif text-xl" style={{ color: "var(--brand-primary)" }}>{settings?.brand_name || "Inchirieri Auto Pascani"}</span>
          )}
        </Link>
        <div className="text-center mb-8">
          <div className="label-eyebrow mb-3" style={{ color: "var(--brand-primary)" }}>{t("login.subtitle")}</div>
          <h1 className="font-serif text-3xl">{t("login.title")}</h1>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input
            required
            type="email"
            placeholder={t("login.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="brand-input"
            data-testid="login-email"
          />
          <input
            required
            type="password"
            placeholder={t("login.password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="brand-input"
            data-testid="login-password"
          />
          {error && <div className="text-sm" style={{ color: "var(--brand-primary)" }} data-testid="login-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-gold-filled w-full" data-testid="login-submit">
            {loading ? "..." : t("login.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
